import { createCustomDimensionsRepository } from './customDimensionsRepository';
import { createECommerceTrackingClient } from './eCommerceTrackingClient';
import { createFirebaseAdapter } from './firebase/firebaseAdapter';
import { setFeatureVariationsToFullstory } from './fullstory';
import {
  createDatalayerUpdater,
  fireDataLayerEvent,
  isTMSVariableGlobal,
  loadContainer,
  syncTcVars,
  trackTMSPage,
} from './tag-commander/datalayer';
import { datalayerStorageClient } from './tag-commander/datalayerStorage';
import { createDatalayerTrackingClient } from './tag-commander/datalayerTrackingClient';
import { flatten } from './tag-commander/utils';
import { createThirdPartyTrackingAgent } from './thirdPartyTrackingAgent';
import { trackPage as trackGAPage } from './thirdPartyTrackingAgent/pages';
import { createTrackingParamsRepository } from './trackingParamsRepository';
import { getMktportalParams } from './trackingParamsRepository/mktportal';
import { getUtmParameters } from './trackingParamsRepository/utm';
import { identifyAnalyticsClient } from './utils/analytics-identification';
import { shouldSkipTracking } from './utils/cookie';

export const thirdPartyTracking = {
  createCustomDimensionsRepository, // WARNING: use only in frontend-shell, frontend-html5 & frontend-home
  createECommerceTrackingClient, // WARNING: use only in frontend-shell, frontend-html5 & frontend-home
  createDatalayerTrackingClient, // WARNING: use only in frontend-shell, frontend-html5 & frontend-home
  /** @deprecated it will be removed in future versions */
  createFirebaseAdapter, // TODO: remove this from frontend-core
  /** @deprecated it will be removed in future versions */
  createDatalayerUpdater, // TODO: this function is deprecated. In product library, use a custom hook from frontend-core
  /** @deprecated it will be removed in future versions */
  getDatalayer: datalayerStorageClient().getDatalayerGlobalParams,
  /** @deprecated it will be removed in future versions */
  fireDataLayerEvent,
  /** @deprecated it will be removed in future versions */
  isTMSVariableGlobal,
  getUtmParams: getUtmParameters,
  identifyAnalyticsClient,
  createThirdPartyTrackingAgent,
  createTrackingParamsRepository,
  /** @deprecated use getUtmParams instead */
  getUtmParameters, // WARNING: use only in frontend-core, frontend-html5 & frontend-home
  getMktportalParams, // WARNING: use only in frontend-core, frontend-html5 & frontend-home
  trackGAPage, // WARNING: use only in frontend-core, frontend-html5 & frontend-home
  trackTMSPage, // WARNING: use only in frontend-core, frontend-html5 & frontend-home
  /** @deprecated it will be removed in future versions */
  syncTcVars,
  /** @deprecated it will be removed in future versions */
  loadContainer,
  flatten,
  /** @deprecated it will be removed in future versions */
  shouldSkipTracking,
  setFeatureVariations: setFeatureVariationsToFullstory,
};
